<script>
  import Headline from './WorkIdHeadline.svelte'
  import ProjectImage from './WorkIdImage.svelte'
</script>

<main class="mb-[128px] mt-[122px]">
  <Headline />
  <ProjectImage />
</main>
